module.exports = __webpack_public_path__ + "img/icon_controltemp_white.ce4ba5e6.svg";